import { Grid } from "@mui/material";
import { ButtonCancel } from "components/buttons";
import { ButtonApplyFilter } from "components/buttons/ButtonApplyFilter";
import { MprcInputStyles } from "components/filter/MprcInputStyles";
import { AutoCompleteDataModel } from "components/MprcAutoComplete";
import { TrainingType } from "generated/CoreApi_v1";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { IAdvFilterPickerProps } from "views/general/AdvancedFilter/interfaces";
import { TrainingAutoComplete } from "views/lms/training/components/TrainingAutoComplete";

////////////////////////////////////////////////////////////////////////////////

export const TrainingPicker: React.FC<IAdvFilterPickerProps> = (props) => {

    const { filter, onError, onApply, onCancel } = props;
    const { t } = useTranslation("shared");
    const [selected, setSelected] = useState<AutoCompleteDataModel[]>([]);
    const inputRef = useRef<HTMLInputElement>(undefined);
    const multiSelect = filter.canRepeat ?? false;

    var trainingType = filter.pickerParams as TrainingType | undefined;

    ////////////////////////////////////////////////////////////////////////////////

    ///
    const handleApply = () => {
        if (selected.length > 0) {
            const newFilter = selected.map(item => ({
                command: filter!.command,
                optionalGroup: filter?.optionGroup,
                text: `${filter?.displayName.replace("...", "")}: ${item.label}`,
                value: item.key,
                quickFilter: null,
                period: null,
                range: null,
                includeDescendants: null
            }));
            onApply(newFilter, filter);
        }
    };

    ////////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////////

    return (
        <Grid container alignItems="flex-end" spacing={2}>
            <Grid size="grow">
                <TrainingAutoComplete
                    autoFocus
                    placeholder={filter.placeholder ?? t(`AdvFilter.Picker.Training.Placeholder${multiSelect ? "_multi" : ""}`)}
                    multiSelect={multiSelect}
                    onlyActive={false}
                    trainingType={trainingType}
                    selectedItems={selected}
                    onChange={(items) => setSelected(items)}
                    onError={onError}
                    onApply={handleApply}
                    onCancel={onCancel}
                    sx={MprcInputStyles.filter}
                    inputRef={inputRef}
                />
            </Grid>
            <Grid>
                <ButtonApplyFilter
                    variant="text"
                    disabled={selected.length == 0}
                    onClick={handleApply}
                />
                <ButtonCancel
                    variant="text"
                    onClick={onCancel}
                />
            </Grid>
        </Grid>
    );
};
